import autoskola from "./Icons/appicon_autoskola-min.png"
import fish from "./Icons/appicon_fish-min.png"
import prof from "./Icons/appicon_profesak-min.png"
import stra from "./Icons/appicon_straznik-min.png"
import zbroj from "./Icons/appicon_zbrojak-min.png"
//import ured from "./Icons/appicon_urednik-min.png"

import cmath from "./Icons/candymath.png"
import gemstone from "./Icons/gemstone.png"

import { appDarkBlue, appYellow, navbarBlue } from "../../Classes/theme";

export const study_apps = [
    { name: 'Autoškola Plus', color: navbarBlue, rating: '4,70', icon: autoskola, link: '/autoskola' },
    { name: 'Zkouška strážníka', color: appDarkBlue, rating: '5,00', icon: stra, link: '/straznik' },
    //{ name: 'Úřednická zkouška', color: "white", rating: '4,80', icon: ured, link: '/urednik', white: true },
    { name: 'Zbrojní průkaz', color: appYellow, rating: '4,80', icon: zbroj, link: '/zbrojak', white: true },
    { name: 'Zkouška rybáře', color: "white", rating: '4,70', icon: fish, link: '/rybar', white: true },
    { name: 'Profesní průkaz', color: appYellow, rating: '4,75', icon: prof, link: '/profesak', white: true },
];

export const fun_apps = [
    { name: 'Gemstone', color: navbarBlue, rating: '5,00', icon: gemstone, link: '/gemstone' },
    { name: 'Candy Math', color: appDarkBlue, rating: '4,75', icon: cmath, link: '/candymath' },
];

export const getAppRatingInfo = (link) => {
    const allApps = [...study_apps, ...fun_apps];
    for (const app of allApps) {
        if (app.link == link) return app;
    }
    return allApps[0];
}